module.exports = __webpack_public_path__ + "static/img/蓝色@2x.7588acf0.png";